export var valuesRegisterRequestResultDto = ["UserCreatedAndApproved", "WaitingForApproval", "UserApproved", "UserApprovedPasswordSet"];
/*

*/ 
//# sourceMappingURL=RegisterRequestResultDto.js.map